import { useMemo } from 'react'

import type { RefNum } from '@fv/models'

import { type RefNumsByType, refNumsByType } from '@/utils/shipmentFuncs'

export const useRefNumsByType = (refNums?: RefNum[]): RefNumsByType => {
  return useMemo(() => refNumsByType(refNums), [refNums])
}
